import publicLinkTemplate from './publicLink.html';

class PublicLinkController {
  static $inject = ['PublicLink'];

  apiUrl: string;
  publicUrl: string;
  publicLinkName: string;
  publicLink: any;

  constructor(private PublicLink) {}

  $onChanges(changes) {
    if (changes.publicLinkName) {
      this.publicLink = null;

      if (this.publicLinkName) {
        this.getPublicLink();
      }
    }
  }

  private withAccessUrl(access) {
    if (access.accessId) {
      access.url = this.publicUrl + '?accessid=' + access.accessId;
    }
    return access;
  }

  getPublicLink() {
    const r = this.PublicLink.get(
      { name: 'ActivityReports-' + this.publicLinkName },
      () => {
        this.publicLink = this.withAccessUrl(r);
      },
      () => {
        this.publicLink = null;
      },
    );
  }

  createPublicLink() {
    const r = this.PublicLink.save(
      {
        name: 'ActivityReports-' + this.publicLinkName,
        url:
          '/api/activityReports/' +
          window.encodeURIComponent(this.publicLinkName),
      },
      () => {
        this.publicLink = this.withAccessUrl(r); // use a callback to avoid blinking
      },
    );
  }
}

export const PublicLinkComponent = {
  template: publicLinkTemplate,
  bindings: {
    apiUrl: '@',
    publicUrl: '@',
    // '=' n'est pas suffisant : $onChanges n'est déclenché que pour '<' et '@'
    publicLinkName: '<',
  },
  controller: PublicLinkController,
};
